import React, { useEffect } from "react";
import * as echarts from "echarts";

function LineChart(props) {
  console.log(props.ques, props.response);
  useEffect(() => {
    // Check if props.que and props.response are defined
    if (props.ques && props.response !== undefined) {
      const chartDom = document.getElementById("line");
      const myChart = echarts.init(chartDom);
      const numberOfQuestions = props.ques.length;
      const numberOfResponses = props.response.length;
      const questionToResponsesMap = {};
      for (let i = 0; i < props.ques.length; i++) {
        const question = props.ques[i];
        const response = props.response[i];

        if (!questionToResponsesMap[question]) {
          questionToResponsesMap[question] = [];
        }

        questionToResponsesMap[question].push(response);
      }

      // Calculate the number of responses per question
      const responsesPerQuestion = {};
      for (const question in questionToResponsesMap) {
        responsesPerQuestion[question] =
          questionToResponsesMap[question].length;
      }
      const data = {
        legend: {},
        tooltip: {},
        xAxis: {
          type: "category",
          data: ["Questions", "Responses"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [numberOfQuestions, numberOfResponses],
            type: "line",
          },
        ],
      };

      const options = {
        responsive: true,
      };

      myChart.setOption(data);
      myChart.setOption(options);
    } else {
      console.log("No Data");
    }
  }, [props.que, props.response]); // Add props.que as dependency if needed

  return (
    <div
      id="line"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "600px",
        height: "400px",
        margin: "auto",
        marginTop: "10px",
      }}
    ></div>
  );
}

export default LineChart;
